@if (jobs) {
  <div class="card mt-2" >
    <div class="card-header">
      <div class="card-header-title">
        Journeys
      </div>
      @if (isOnExportUsed) {
        <button  (click)="exportData()" class="btn btn-white btn-sm float-right">
          Export Data
          <span class="svg-icon svg-icon-xs ms-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>ionicons-v5-a</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
          </span>
        </button>
      }
    </div>
    <div class="table-responsive">
      <table class="table table-sm card-table table-wrap" aria-labelledby="tableLabel">
        <thead>
          <tr>
            <th class="vehicle">Vehicle</th>
            <th class="departed">Dep</th>
            <th class="location1">From Location</th>
            <th class="asset text-center">Cont</th>
            <th class="time text-center">Time</th>
            <th class="mileage text-center">Mileage</th>
            <th class="location2">To location</th>
            <th class="arrived">Arr</th>
            <th class="var1 text-center" title="Journey Time Variance">TVA</th>
            <th class="var2 text-center" title="Mileage Time Variance">MVA</th>
          </tr>
        </thead>
        <tbody>
          @for (job of jobsPage; track job) {
            <tr [className]="job.alert && dashboardMode != DashboardMode.Irregular ? 'warning' : ''" (click)="goToRouteMap(job.movementId)">
              <td class="vehicle"><div class="trunc">{{ job.vehicleName }}</div></td>
              <td class="departed" title="{{ job.departedAt | date:'mediumDate' }}"><div class="trunc">{{ job.departedAtFormatted }}</div></td>
              <td class="location1"><div class="trunc" [title]="job.fromLocation">{{ job.fromLocation }}</div></td>
              <td class="asset text-center">
                <div class="trunc" [title]="job.containerId">
                  @if (job.containerId && job.toLocationId && job.arrivedAtIso && job.hasDeliveryPhotographs) {
                    <a class="delivery-link" [routerLink]="['/delivery-images']" [queryParams]="{ assetId: job.containerId, locationId: job.toLocationId, arrivedAt: job.arrivedAtIso }" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
                      {{ job.containerId }}
                    </a>
                  } @else {
                    {{ job.containerId }}
                  }
                </div>
              </td>
              <td class="time text-center"><div class="trunc">{{ job.journeyTimeMinutesFormatted }}</div></td>
              <td class="mileage text-center"><div class="trunc">{{ job.mileageFormatted }}</div></td>
              <td class="location2" [title]="job.toLocation"><div class="trunc">{{ job.toLocation }}</div></td>
              <td class="arrived" title="{{ job.departedAt | date:'mediumDate' }}"><div class="trunc">{{ job.arrivedAtFormatted }}</div></td>
              <td class="var1 text-center"><div [className]="job.variance == 0 ? 'trunc' : job.variance > 0 ? 'warning trunc' : 'good trunc'">{{ job.variance }}</div></td>
              <td class="var2 text-center"><div [className]="job.mileageVariance == 0 ? '' : job.mileageVariance > 0 ? 'warning trunc' : 'good trunc'">{{ job.mileageVarianceFormatted }}</div></td>
            </tr>
          }
        </tbody>
        <tbody class="list">
          <tr>
            <td class="h-2" colspan="8"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
}
